class StockObjectiveDetails {
    constructor({ version, totalTargetedValue, totalInvestmentTargetedAmount, totalTargetedShareCount, percentageOfTotalInvestmentValue }) {
        this._version = version
        this._totalTargetedValue = totalTargetedValue
        this._totalInvestmentTargetedAmount = totalInvestmentTargetedAmount
        this._totalTargetedShareCount = totalTargetedShareCount
        this._percentageOfTotalInvestmentValue = percentageOfTotalInvestmentValue
    }

    get version() { return this._version }
    get totalTargetedValue() { return this._totalTargetedValue }
    get totalInvestmentTargetedAmount() { return this._totalInvestmentTargetedAmount }
    get totalTargetedShareCount() { return this._totalTargetedShareCount }
    get percentageOfTotalInvestmentValue() { return this._percentageOfTotalInvestmentValue }
}

export default StockObjectiveDetails